export interface ClubhouseMemberPermissions {
    discussionsVotingPermission: ClubhouseMemberDiscussionsVotingPermission;
    messagesAvailabilityPermission: ClubhouseMemberMessagesAvailabilityPermission;
    messagesReviewPermission: ClubhouseMemberMessagesReviewPermission;
    messagesSendPermission: ClubhouseMemberMessagesSendPermission;
}

export enum ClubhouseMemberDiscussionsVotingPermission {
    Allowed = 0,
    NotAllowed = 1,
}

export enum ClubhouseMemberMessagesAvailabilityPermission {
    AllAvailable = 0,
    ApprovedOnly = 1,
    
}

export enum ClubhouseMemberMessagesReviewPermission {
    CannotReview = 0,
    CanReview = 1,
}

export enum ClubhouseMemberMessagesSendPermission {
    AvailableToAll = 0,
    NeedsReview = 1,
    Readonly = 2
}
